import type { FC } from 'react';
import { Button, Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useGetServiceProviderPhoenix } from '@pflegenavi/service-provider-frontend/api';
import { Iconify, Label } from '@pflegenavi/web-components';

export const BankAccountCard: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: serviceProvider } = useGetServiceProviderPhoenix();

  const hasBankAccount = Boolean(
    serviceProvider?.data?.mangopay_bank_account_id
  );

  const handleSetupBankAccount = () => {
    navigate(spAppMainPages.SETUP_BANK_ACCOUNT);
  };

  return (
    <Card sx={{ p: 2 }}>
      <Stack gap={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <Iconify icon="mdi:bank" width={24} height={24} />
            <Typography variant="subtitle1">
              {t('service-provider-app.profile.bank-account')}
            </Typography>
          </Stack>
          {hasBankAccount ? (
            <Label color="success">
              {t('service-provider-app.profile.configured')}
            </Label>
          ) : (
            <Label color="warning">
              {t('service-provider-app.profile.not-configured')}
            </Label>
          )}
        </Stack>

        <Typography variant="body2" color="text.secondary">
          {hasBankAccount
            ? t(
                'service-provider-app.profile.bank-account-configured-description'
              )
            : t(
                'service-provider-app.profile.bank-account-not-configured-description'
              )}
        </Typography>

        <Button
          variant={hasBankAccount ? 'outlined' : 'contained'}
          onClick={handleSetupBankAccount}
          startIcon={
            <Iconify icon={hasBankAccount ? 'mdi:pencil' : 'mdi:plus'} />
          }
          fullWidth
        >
          {hasBankAccount
            ? t('service-provider-app.profile.update-bank-account')
            : t('service-provider-app.profile.setup-bank-account')}
        </Button>
      </Stack>
    </Card>
  );
};
